// Actions
export const DISPLAY_BLOCKUI = 'DISPLAY_BLOCKUI';
export const HIDE_BLOCKUI = 'HIDE_BLOCKUI';

// Reducer
interface BlockUIAction {
  type: string;
}

export interface BlockUIReducerState {

}

const initialState: BlockUIReducerState = {

};

export const blockUIReducer =
  (state: BlockUIReducerState = initialState, action: BlockUIAction): BlockUIReducerState => {
    switch (action.type) {
      case DISPLAY_BLOCKUI:
        return {
        };
      case HIDE_BLOCKUI:
        return {
        };
      default:
        return state;
    }
  };

// Action Creators
export interface DisplayBlockUI {
  (): (dispatch: Function) => void;
}

export const displayBlockUI: DisplayBlockUI = () => {
  return (dispatch: Function) => {
    dispatch({ type: DISPLAY_BLOCKUI });
  };
};

export interface HideBlockUI {
  (): (dispatch: Function) => void;
}

export const hideBlockUI: HideBlockUI = () => {
  return (dispatch: Function) => {
    dispatch({ type: HIDE_BLOCKUI });
  };
};
